import { ArrowRight } from "lucide-react";
import { Chapter, Reveal } from "@/components/Reveal";
import { PrimaryCTA, GhostCTA } from "@/components/CTA";

const SERVICES = [
  { t: "SOCIAL MEDIA MANAGEMENT", d: "Gestione operativa della presenza social delle aziende." },
  { t: "CONTENT CREATION", d: "Contenuti, reel, creatività e storytelling." },
  { t: "WEB EXPERIENCE", d: "Siti web moderni, dinamici, responsive e orientati all'esperienza dell'utente." },
  { t: "AI & AUTOMATION", d: "Applicazioni e automazioni digitali basate sull'intelligenza artificiale." },
];

const DeltaPage = () => (
  <div data-testid="delta-page" className="relative overflow-hidden bg-ink pt-[72px] text-white">
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -right-10 top-10 select-none font-display text-[42vw] font-extrabold leading-none text-accent/[0.05]"
    >
      Δ
    </span>

    <div className="relative mx-auto max-w-[1440px] px-6 py-20 lg:px-12 lg:py-32">
      <Chapter index="Δ" label="Delta Digital Agency" dark />
      <Reveal>
        <h1 className="max-w-4xl font-display text-[clamp(2.6rem,7vw,5.5rem)] font-extrabold leading-[1.02] tracking-tighter">
          Il braccio operativo <span className="text-accent">digitale</span>.
        </h1>
        <p className="mt-8 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
          La strategia senza esecuzione rimane soltanto una buona idea. Quando la strategia richiede
          anche execution, un team dedicato la trasforma in operatività.
        </p>
        <p className="mt-5 max-w-xl font-mono text-[11px] uppercase leading-relaxed tracking-[0.2em] text-white/35">
          Delta Digital Agency è l'estensione operativa della consulenza strategica di Mattia Cosimo
          Saracino.
        </p>
      </Reveal>

      <div className="mt-20 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.t} delay={i * 0.07}>
            <article
              data-testid={`delta-page-service-${i + 1}`}
              className="h-full border border-white/10 p-8 transition-colors duration-500 hover:border-accent"
            >
              <span className="font-mono text-[10px] tracking-[0.3em] text-accent">0{i + 1}</span>
              <h2 className="mt-6 font-display text-lg font-bold tracking-tight">{s.t}</h2>
              <p className="mt-4 text-sm leading-relaxed text-white/50">{s.d}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-24">
        <div className="flex flex-wrap items-center gap-8 border-y border-white/10 py-14" data-testid="delta-page-before-after">
          <span className="font-display text-3xl font-extrabold tracking-tighter text-white/40 sm:text-4xl">
            BEFORE
          </span>
          <ArrowRight className="h-5 w-5 text-white/25" aria-hidden="true" />
          <span className="font-display text-7xl font-extrabold leading-none text-accent sm:text-8xl">Δ</span>
          <ArrowRight className="h-5 w-5 text-white/25" aria-hidden="true" />
          <span className="font-display text-3xl font-extrabold tracking-tighter text-white sm:text-4xl">
            AFTER
          </span>
        </div>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          Δ rappresenta il cambiamento.
        </p>
      </Reveal>

      <Reveal className="mt-24">
        <img
          src="https://images.unsplash.com/photo-1758073519996-6d3c63b4922c?auto=format&fit=crop&w=1600&q=70"
          alt="Astratto digitale — Delta Digital Agency"
          loading="lazy"
          className="h-[320px] w-full border border-white/10 object-cover lg:h-[420px]"
        />
      </Reveal>

      <Reveal delay={0.1} className="mt-20 flex flex-wrap gap-4">
        <PrimaryCTA testid="delta-page-cta">Parliamone</PrimaryCTA>
        <GhostCTA to="/" dark testid="delta-page-back">
          Torna alla consulenza
        </GhostCTA>
      </Reveal>
    </div>
  </div>
);

export default DeltaPage;
